import router from './router'

const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  const hasToken = localStorage.getItem('sys_token')
  if (hasToken) {
    if (to.path === '/login') {
      if (to.query.redirect_url) {
        const token = localStorage.getItem('sys_token')
        const expireTime = localStorage.getItem('expireTime')
        window.location.href = `${decodeURIComponent(to.query.redirect_url)}&token=${token}&expireTime=${expireTime}`
      } else {
        next({ path: '/' })
      }
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})
